import styled from '@emotion/styled';

import { Table as BaseTable } from 'components/Table';

export const ResultsTableStyled = styled.div`
  margin-top: 1.5rem;
`;

export const FiltersWrapper = styled.div`
  border-bottom: 1px solid #eee;
  margin-bottom: 0.92rem;
`;

export const Filter = styled.a`
  display: inline-block;
  margin-top: 0.85rem;
  padding: 0 0.85rem 0.85rem;
  font-size: 0;
  cursor: pointer;

  color: ${({ selected, theme }) => (selected ? theme.colors.textDark : '#808080')};

  font-weight: ${({ selected, theme }) => (selected ? 'bold' : 'normal')};

  border-bottom: ${({ selected, theme }) =>
    selected ? `3px solid ${theme.colors.action}` : 'normal'};
`;

export const FilterLabel = styled.span`
  display: inline-block;
  margin-right: 8px;
  vertical-align: middle;
  font-size: 14px;
`;

export const Table = styled(BaseTable)`
  margin-top: 0.92rem;

  th:first-of-type {
    width: 40%;
    padding-left: 0.78rem;
  }
  th {
    background: ${({ theme }) => theme.colors.tableHeader};
  }
`;

export const Badge = styled.span`
  display: inline-block;
  padding: 0.35rem 0.4rem;
  color: ${({ theme }) => theme.colors.textLight};
  background: ${({ theme }) => theme.colors.secondary};
  font-size: 75%;
  text-align: center;
  white-space: nowrap;
  border-radius: 0.25rem;
  vertical-align: middle;
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
`;

export const NoOldCasesMessage = styled.div`
  padding: 0.4rem 0;
  font-weight: 300;
`;
